<template>
    <h2>
        Clockmaker admin system
    </h2>
</template>

<script>
      
    export default {
        name: 'home',  
    };

</script>


// WEBPACK FOOTER //
// src/components/home.vue